import uamfApiErrorMessages from '../../consts/uamf/uamfApiErrorMessages';
import deviceHelpers from '../device/deviceHelpers';

const checkIsActiveRequestAlreadyExistsError = (dusn, error) =>
    deviceHelpers.getIsIlumaI5ByDusn(dusn) &&
    error?.response?.data?.error?.message === uamfApiErrorMessages.ACTIVE_REQUEST_ALREADY_EXISTS;

export default {
    checkIsActiveRequestAlreadyExistsError,
};
